import React from 'react';
import {
  Col, ProgressBar, Row, Card,
} from 'react-bootstrap';
import { ReactComponent as IconCheck } from 'assets/icons/check2.svg';

type HorizontalTimelineProps = {
  steps: Array<{
    header: string
    title: string
    subtitle: string
    progress?: number
  }>
};

const NBSP = '\u00A0';
function HorizontalTimeline( { steps }: HorizontalTimelineProps ) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const totalProgress = steps.reduce( ( sum, step ) => sum + ( step.progress ?? 0 ), 0 );
  const totalSteps = steps.length;
  const progressPercent = totalSteps > 0 ? ( 200 / ( totalSteps * 100 ) ) * 100 : 0;

  if ( steps.length === 0 ) return null;
  return (
    <Card className="card--light">
      <Card.Body className="pt-xl">
        <h1 className="title-xl text--bold">Fases del proyecto</h1>

        <div className="pt-5">

          <div className="overflow-lg-auto">
            <div className="timeline-container">
              <Row>
                {steps.map( ( step ) => (
                  <Col xs className="timeline-step" key={step.title}>
                    <div className="timeline-quarter">{step.header || NBSP}</div>
                    <div className="timeline-icon">
                      <span className="checkmark">
                        <IconCheck />
                      </span>
                    </div>
                    <div className="timeline-title">{step.title}</div>
                    <div className="timeline-subtitle">{step.subtitle}</div>
                  </Col>
                ) )}
              </Row>

              <div>
                <ProgressBar className="horizontal-timeline" now={progressPercent} />
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default HorizontalTimeline;
